import style from "css/myreservation.module.css";
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import moment from "moment";
import "moment/locale/ko";

import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import momentPlugin from "@fullcalendar/moment";
import Calendar from "@fullcalendar/react";

import { ConfigProvider, DatePicker, Segmented, Select } from 'antd';
import { updateCalendarRange } from "redux/slices/calendarRangeSlice";
import HourlyCalendar from './hourlyCalendar';

import { ReactComponent as Next } from "asset/calendar/next.svg";
import { ReactComponent as Prev } from "asset/calendar/prev.svg";
import { ReactComponent as Refresh } from "asset/calendar/refresh.svg";
import dayjs from 'dayjs';

function DailyCalendar({ scheduleList }) {
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();
    const calendarRangePayload = useSelector((state) => state.calendarRange);

    const calendarRef = useRef(null);

    const [init, setInit] = useState(true);
    const [calendarApi, setCalendarApi] = useState();
    const [calendarViewType, setCalendarViewType] = useState(null);
    const [calendarViewHeight, setCalendarViewHeight] = useState(400);
    const [selectedDate, setSelectedDate] = useState(null);
    const [titleMonth, setTitleMonth] = useState(dayjs());
    const [title, setTitle] = useState("");

    // 주,월간 switcher
    const changeViewType = (type) => {
        if (type === calendarApi.view.type) {
            return;
        }
        if (type === "dayGridMonth" && calendarApi.view.type === "dayGridWeek") {
            calendarApi.changeView("dayGridMonth", selectedDate);
            setCalendarViewHeight(400);
        } else if (
            type === "dayGridWeek" &&
            calendarApi.view.type === "dayGridMonth"
        ) {
            calendarApi.changeView("dayGridWeek", selectedDate);
            setCalendarViewHeight(105);
        }
        setTitle(
            i18n.language === "en-US"
                ? moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
                : moment(calendarApi.view.currentStart).locale("ko").format("YYYY년 M월")
        );
        setCalendarViewType(calendarApi.view.type);
        let activeStart = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
        let activeEnd = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
        const obj = {
            VIEW: type,
            ACTIVE_START: activeStart,
            ACTIVE_END: activeEnd,
        };
        dispatch(updateCalendarRange(obj));
    };

    const dayConverter = (value, rtnToday) => {
        const isToday = moment(value).isSame(moment(), "day");
        if (isToday && rtnToday) return "Today";
        if (i18n.language === "en-US") {
            return moment(value).locale("en").format("ddd");
        } else {
            return moment(value).locale("ko").format("dd");
        }
    };

    const localeConverter = () => {
        if (i18n.language === "en-US") {
            return "en";
        } else {
            return "ko";
        }
    };

    const calendarClickDate = (e) => {
        setSelectedDate(moment(e).locale('ko').format("YYYY-MM-DD"));
    }

    const selectMeetingOptions = [
        { value: "dayGridWeek", label: t("BTN.WEEK") },
        { value: "dayGridMonth", label: t("BTN.MONTH") },
    ];

    const todayRefresh = () => {
        calendarClickDate(moment().format("YYYY-MM-DD"))
    }

    const monthlyMovePrev = () => {
        calendarApi.prev();
        setSelectedDate(moment(calendarApi.view.currentEnd).subtract(1, "days").format("YYYY-MM-DD"))
        setTitle(
            i18n.language === "en-US"
                ? moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
                : moment(calendarApi.view.currentStart).locale("ko").format("YYYY년 M월")
        );
        setTitleMonth(dayjs(calendarApi.view.currentStart));
        let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
        let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");

        const obj = {
            VIEW: calendarApi.view.type,
            ACTIVE_START: start,
            ACTIVE_END: end,
        };
        dispatch(updateCalendarRange(obj));
    };

    const monthlyMoveNext = () => {
        calendarApi.next();
        setSelectedDate(moment(calendarApi.view.currentStart).format("YYYY-MM-DD"))
        setTitle(
            i18n.language === "en-US"
                ? moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
                : moment(calendarApi.view.currentStart).locale("ko").format("YYYY년 M월")
        );
        setTitleMonth(dayjs(calendarApi.view.currentStart));
        let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
        let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
        const obj = {
            VIEW: calendarApi.view.type,
            ACTIVE_START: start,
            ACTIVE_END: end,
        };
        dispatch(updateCalendarRange(obj));
    };

    const weeklyMovePrev = () => {
        calendarApi.prev();
        setSelectedDate(moment(calendarApi.view.currentEnd).subtract(1, "days").format("YYYY-MM-DD"))
        setTitle(
            i18n.language === "en-US"
                ? moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
                : moment(calendarApi.view.currentStart).locale("ko").format("YYYY년 M월")
        );
        setTitleMonth(dayjs(calendarApi.view.currentStart));
        let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
        let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");

        const obj = {
            VIEW: calendarApi.view.type,
            ACTIVE_START: start,
            ACTIVE_END: end,
        };
        dispatch(updateCalendarRange(obj));
    };

    const weeklyMoveNext = () => {
        calendarApi.next();
        setSelectedDate(moment(calendarApi.view.currentStart).format("YYYY-MM-DD"))
        setTitle(
            i18n.language === "en-US"
                ? moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
                : moment(calendarApi.view.currentStart).locale("ko").format("YYYY년 M월")
        );
        setTitleMonth(dayjs(calendarApi.view.currentStart));
        let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
        let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
        const obj = {
            VIEW: calendarApi.view.type,
            ACTIVE_START: start,
            ACTIVE_END: end,
        };
        dispatch(updateCalendarRange(obj));
    };

    const calendarMoveMonth = (month) => {
        calendarApi.changeView(calendarApi.view.type, month);
        setTitle(
            i18n.language === "en-US"
                ? moment(calendarApi.view.currentStart).locale("en").format("MMMM YYYY")
                : moment(calendarApi.view.currentStart).locale("ko").format("YYYY년 M월")
        );
        let start = moment(calendarApi.view.activeStart).format("YYYY-MM-DD");
        let end = moment(calendarApi.view.activeEnd).format("YYYY-MM-DD");
        const obj = {
            VIEW_TYPE: calendarApi.view.type,
            ACTIVE_START: start,
            ACTIVE_END: end,
        };
        dispatch(updateCalendarRange(obj));
    };

    useEffect(() => {
        if (calendarRef !== undefined) {
            const calApi = calendarRef.current.getApi();
            const today = moment().format("YYYY-MM-DD");
            if (init) {
                setCalendarApi(calApi);
                setCalendarViewType(calApi.view.type);
                setSelectedDate(today);
                // setSelectedDateSchedule(todaySchedule);
                const activeStart = moment(calApi.view.activeStart).format("YYYY-MM-DD");
                const activeEnd = moment(calApi.view.activeEnd).format("YYYY-MM-DD");
                const obj = {
                    VIEW: calApi.view.type,
                    ACTIVE_START: activeStart,
                    ACTIVE_END: activeEnd,
                };
                dispatch(updateCalendarRange(obj));
                setInit(false);
            }

            setTitle(
                i18n.language === "en-US"
                    ? moment(calApi.view.currentStart).locale("en").format("MMMM YYYY")
                    : moment(calApi.view.currentStart).locale("ko").format("YYYY년 M월")
            );

            // 캘린더 모든 날짜 셀 선택
            const calendarDateCells = document.querySelectorAll(".calendar-monthly .fc.fc.fc-theme-standard td");

            if (calApi.view.type === "dayGridWeek") {
                const calendarHeaderCells = document.querySelectorAll(".calendar-monthly .fc.fc.fc-theme-standard .fc-dayGridWeek-view th");

                // 주간 캘린더 요일 컬러
                for (let i = 0; i < calendarHeaderCells.length; i++) {
                    const calendarHeaderCell = calendarHeaderCells[i];
                    const headerDate = calendarHeaderCell.getAttribute("data-date");
                    const date = calendarHeaderCell.querySelector(".date");
                    const weekday = calendarHeaderCell.querySelector(".weekday");

                    if (new Date(today) <= new Date(headerDate)) {  // 미래
                        date.style.color = "#000"
                        weekday.style.color = "#000"
                    }
                    if (new Date(headerDate) < new Date(today)) {   // 과거
                        date.style.color = "#808080"
                        weekday.style.color = "#808080"
                    }
                    if (headerDate === selectedDate) {  // 선택한 날
                        date.style.color = "#1cb691"
                        weekday.style.color = "#1cb691"
                    }
                }

                const calendarDataCells = document.querySelectorAll(".calendar-monthly .fc.fc.fc-theme-standard .fc-dayGridWeek-view td");
                // 주간 캘린더 하단 컬러
                calendarDataCells.forEach(cell => {
                    const cellDate = cell.getAttribute("data-date");
                    const inner = cell.querySelector('.fc-scrollgrid-sync-inner');

                    if (cellDate === selectedDate) {
                        inner.style.borderBottom = '2px solid #1cb691'
                    } else {
                        inner.style.borderBottom = '2px solid #fff'
                    }
                })
            }

            for (let i = 0; i < calendarDateCells.length; i++) {
                const calendarDateCell = calendarDateCells[i];
                let isHotdesking = false;   // 캘린더에 hotdesking 동그라미 중복 입력 방지
                let isMeeting = false;      // 캘린더에 회의 동그라미 중복 입력 방지
                let buttons = "";

                // 월간 캘린더 today indicator START
                const calendarDate = calendarDateCell.getAttribute("data-date");

                if (calApi.view.type === "dayGridMonth") {
                    const allTds = document.querySelectorAll(".calendar-monthly .fc.fc.fc-theme-standard .fc-scrollgrid-sync-inner");
                    allTds.forEach(td => td.style.borderBottom = 'none')
                    // 요일
                    const calendarDays = document.querySelectorAll(".calendar-monthly .fc.fc.fc-theme-standard .fc-col-header-cell .calendar-item-day-header");
                    // console.log("calendarDays ", calendarDays)
                    calendarDays.forEach(day => day.style.color = "#000")
                    // 선택한 날짜에 초록 동그라미 indicator
                    const calenderNumberArea = calendarDateCell.querySelector(".fc-daygrid-day-number");

                    if (calendarDate !== null) {
                        if (new Date(today) <= new Date(calendarDate)) {
                            calenderNumberArea.style.backgroundColor = "#fff";
                            calenderNumberArea.style.color = "#000";
                        }
                        if (new Date(calendarDate) < new Date(today)) {
                            calenderNumberArea.style.backgroundColor = "#fff";
                            calenderNumberArea.style.color = "#595959";
                        }
                        if (calendarDate === selectedDate) {
                            calenderNumberArea.style.borderRadius = "50%";
                            calenderNumberArea.style.backgroundColor = "#1cb691";
                            calenderNumberArea.style.color = "#fff";
                        }
                    }
                }

                // 스케줄 동그라미
                scheduleList.forEach(schedule => {
                    const scheduleDate = moment(schedule.start).format("yyyy-MM-DD");

                    // 스케줄을 타입에 따라 달력에 유무 표출해주기
                    if (calendarDate === scheduleDate && schedule.resourceId === 'M' && !isMeeting) {
                        buttons += "<div class='mscd-circle' style='background-color: #1cb691'></div>"
                        isMeeting = true;
                    }
                    if (calendarDate === scheduleDate && schedule.resourceId === 'H' && !isHotdesking) {
                        buttons += "<div class='mscd-circle' style='background-color: #a3cc18'></div>"
                        isHotdesking = true;
                    }

                })

                const tmp_inner = calendarDateCell.querySelector(".fc-daygrid-day-events");

                if (buttons !== "") tmp_inner.innerHTML = buttons;
                else tmp_inner.innerHTML = "<div></div>";
            }
        }
    }, [calendarRangePayload, dispatch, i18n.language, init, scheduleList, selectedDate]);

    return (
        <div className={style.calendar_wrapper}>
            <div className={style.calendar_header}>
                <div className={style.left}>
                    <button className={style.today_btn} onClick={todayRefresh}>
                        {t("BTN.TODAY")}
                        <Refresh />
                    </button>
                    {/* <Select
                        // defaultValue={calendarViewType}
                        value={calendarViewType}
                        style={{ width: 92, height: 38 }}
                        onChange={(value) =>
                            changeViewType(value)
                        }
                        options={selectMeetingOptions}
                    /> */}
                    <ConfigProvider
                        theme={{
                            components: {
                                Segmented: {
                                    colorText: "#1cb691",
                                    colorTextLabel: "#7b7b7b",
                                    padding: 23,
                                    fontFamily: "Spoqa Han Sans Neo",
                                },
                            },
                        }}
                    >
                        <Segmented
                            size="large"
                            options={selectMeetingOptions}
                            value={calendarViewType}
                            onChange={value => changeViewType(value)}
                        />
                    </ConfigProvider>
                </div>
                <div className={style.right}>
                    <div>
                        <div style={{ width: 12, height: 12, backgroundColor: "#1cb691", borderRadius: "100%", border: "none" }} />
                        {i18n.language === "ko-KR" ? "회의실" : "Meeting Room"}
                    </div>
                    <div>
                        <div style={{ width: 12, height: 12, backgroundColor: "#a3cc18", borderRadius: "100%", border: "none" }} />
                        Hot Desking
                    </div>
                </div>
            </div>
            {calendarViewType === "dayGridMonth" &&
                <div className='monthly-nav'>
                    <Prev onClick={monthlyMovePrev} className='nav-btn' />
                    <div className={style.month_picker}>
                        <label htmlFor="MonthPicker" style={{ cursor: 'pointer' }}>
                            <div className={style.title}>{title}</div>
                        </label>
                        <ConfigProvider
                            theme={{
                                token: {
                                    fontFamily: "Spoqa Han Sans Neo",
                                },
                            }}
                        >
                            <DatePicker
                                style={{ visibility: "hidden", height: 0, width: 0, padding: 0, border: 'none', position: 'absolute' }}
                                id="MonthPicker"
                                name="MonthPicker"
                                picker="month"
                                format={"MMMM YYYY"}
                                // bordered={false}
                                value={titleMonth}
                                onChange={(date) => {
                                    setTitleMonth(dayjs(date, "YYYY-MM"));
                                    calendarMoveMonth(date.format("YYYY-MM"));
                                }}
                                inputReadOnly={true}
                            />
                        </ConfigProvider>
                    </div>
                    <Next onClick={monthlyMoveNext} className='nav-btn' />
                </div>
            }
            {calendarViewType === "dayGridWeek" &&
                <div className='weekly-title'>{title}</div>
            }
            <div className='calendar-monthly'>
                {calendarViewType === "dayGridWeek" && <Prev className='weekly-nav-btn' onClick={weeklyMovePrev} />}
                <Calendar
                    contentHeight={calendarViewHeight}
                    ref={calendarRef}
                    plugins={
                        [
                            dayGridPlugin,
                            // timeGridPlugin,
                            interactionPlugin,
                            momentPlugin,
                        ]}
                    initialView="dayGridMonth"
                    timeZone="Asia/Seoul"
                    locale={localeConverter()}
                    expandRows={true}
                    dayMaxEventRows={true}
                    headerToolbar={false}
                    views={{
                        dayGridMonth: {
                            titleFormat: "YYYY년 M월",
                            dayPopoverFormat: "YYYY. M. D ",
                            dateClick: function (e) {
                                calendarClickDate(e.date);
                            },
                            displayEventTime: true,
                            selectable: false, //사용자가 클릭하여 끌어서 여러 일 또는 시간대를 강조 표시하도록 허용.
                            selectMirror: false, //드래그한 영역 표시
                            dayHeaderContent: function (arg) {
                                //요일 컨트롤
                                return {
                                    html:
                                        "<div class='calendar-item-day-header'>" +
                                        dayConverter(arg.date, false) +
                                        "</div>",
                                };
                            },
                            dayCellContent: function (arg) {
                                //날짜 컨트롤
                                return {
                                    html:
                                        "<div class='fc-daygrid-day-number'>" +
                                        moment(arg.date).format("DD") +
                                        "</div>",
                                };
                            },
                            eventTimeFormat: {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            },
                            eventContent: function (arg) {
                                //스케줄 컨트롤
                                return {
                                    html:
                                        "<div style='display: none'></div>"
                                };
                            },
                            eventDrop: function (info) {
                                info.revert();
                                return;
                            },
                            eventResize: function (info) {
                                info.revert();
                                return;
                            },
                        },
                        dayGridWeek: {
                            titleFormat: "YYYY년 M월",
                            dayPopoverFormat: "YYYY. M. D ",
                            dateClick: function (e) {
                                calendarClickDate(e.date);
                            },
                            displayEventTime: true,
                            selectable: false, //사용자가 클릭하여 끌어서 여러 일 또는 시간대를 강조 표시하도록 허용.
                            selectMirror: false, //드래그한 영역 표시
                            dayHeaderContent: function (arg) {
                                const weekDay = dayConverter(arg.date, true);
                                return {
                                    html:
                                        "<div " +
                                        "class= 'weekday'" +
                                        (weekDay === 'Today' && "style='color: #1cb691'") +
                                        ">" +
                                        weekDay +
                                        "</div>" +
                                        "<div class='date'>" +
                                        moment(arg.date).format("DD") +
                                        "</div>",
                                };
                            },
                            eventTimeFormat: {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                            },
                            eventContent: function (arg) {
                                //스케줄 컨트롤
                                return {
                                    html:
                                        "<div style='display: none'></div>"
                                };
                            },
                            eventDrop: function (info) {
                                info.revert();
                                return;
                            },
                            eventResize: function (info) {
                                info.revert();
                                return;
                            },
                        },
                    }}
                    allDaySlot={false} //Week,day 일때 all-day 슬롯 표출 여부
                    events={scheduleList}
                    nowIndicator={false} //현재 시간을 나타내는 마커를 표시할지 여부.
                    editable={true} // enable draggable events
                    dragScroll={true}
                    eventDurationEditable={true} //크기를 조정하여 이벤트 기간을 편집할 수 있도록 허용. 드래그로 크기조정
                    eventStartEditable={true} //끌기를 통해 이벤트의 시작 시간을 편집할 수 있도록 허용. 드래그앤드랍
                    selectOverlap={true} //사용자가 이벤트에 의해 점유되는 기간을 선택할 수 있는지 여부를 결정한다.
                    unselectAuto={false} //페이지의 다른 곳을 클릭하면 현재 선택 항목이 지워지는지 여부.
                    showNonCurrentDates={false}
                />
                {calendarViewType === "dayGridWeek" && <Next className='weekly-nav-btn' onClick={weeklyMoveNext} />}
            </div>
            <HourlyCalendar scheduleList={scheduleList} date={selectedDate} monthlyCalType={calendarViewType} />
        </div>
    )
}

export default DailyCalendar
